
import storeCode from '~/mixins/storeCode'
import virtualProducts from '~/mixins/virtualProducts'

export default {
  name: 'ProductPageTabsAccordion',
  mixins: [
    storeCode,
    virtualProducts,
  ],

  data () {
    return {
      tabs: ['inMedical', 'additionalBenefits', 'additionalInformation'],
      vendorId: null,
      virtualCategory: {
        isRedirecting: false,
      },
    }
  },

  computed: {
    productType () {
      return this.product._typename || ''
    },

    showComposedInDescription () {
      return this.isMedistoreStore && !['PhysicalProduct'].includes(this.productType)
    },

    getContentForVirtualCategory () {
      let content

      switch (this.$i18n.locale) {
        case 'pl': content = this.getVirtualCategoryByRoute[0].content
          break
        case 'en': content = this.getVirtualCategoryByRoute[0].contentEn
          break
      }

      return content
    },

    getFaqForVirtualCategory () {
      return [1, 2, 3, 4].reduce((acc, value) => {
        if (this.getVirtualCategoryByRoute[0][`question${value}`] && this.getVirtualCategoryByRoute[0][`answer${value}`]) {
          acc.push({
            id: value,
            question: this.getVirtualCategoryByRoute[0][`question${value}`],
            answer: this.getVirtualCategoryByRoute[0][`answer${value}`],
            isFaq: true,
          })
        }
        return acc
      }, [])
    },

    isPhysicalProduct () {
      return ['PhysicalProduct'].includes(this.productType)
    },

    isFaq () {
      return this.getFaqForVirtualCategory.length > 0
    },

    getProductDocuments () {
      const vendorsWithOwnProducts = ['medicover', 'rehasport', 'damian', 'synevo']

      // if vendor has own products, show Documets Tab
      if (vendorsWithOwnProducts.includes(this.$config.storeCode)) {
        return this.product.productSiteAttachments
      }

      if ([
        'AppointmentProduct',
        'AppointmentWithDoctorProduct',
        'PackagedService',
        'PhysicalProduct',
        'MedicalPackageProduct',
      ].includes(this.productType)) {
        return this.product.productSiteAttachments
      }

      return this.product.productSiteAttachments.reduce((acc, item) => {
        if (+item.vendorId === +this.product.vendors[0].vendorId) {
          acc.push(item)
        }
        return acc
      }, [])
    },
  },
}
